import { render, staticRenderFns } from "./list_tips_page.vue?vue&type=template&id=40d196db&scoped=true"
import script from "./list_tips_page.vue?vue&type=script&lang=js"
export * from "./list_tips_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d196db",
  null
  
)

export default component.exports